import { ATTACHMENT_LIST_REQUEST } from "../actions/action-types"
import {
    attachmentListCachedResponse,
    attachmentListErrorResponse,
    attachmentListResponse
} from "../actions/attachment-actions"
import { getAttachmentList } from "../api/attachment-api"
import { requestListEpic } from "../epics/default-epics/default-entity-epics"

export const requestAttachmentListEpic = requestListEpic(
    ATTACHMENT_LIST_REQUEST,
    getAttachmentList,
    "topicAttachments",
    attachmentListResponse,
    attachmentListCachedResponse,
    attachmentListErrorResponse
)
